import './ProgressRing.css';
import { t } from '../copy/strings';
import { fmtSections } from '../format/numbers';

export interface ProgressRingProps {
  /** % das seções no momento do evento (0 a 1). */
  fraction: number;
  /** 24 px (feed) ou 22 px (`TvTicker`). */
  size?: 24 | 22;
  /** Sozinho: `role="img"` + `ring.aria`. Padrão: decorativo (o texto ao lado diz o %). */
  standalone?: boolean;
}

/** Raio do anel no viewBox de 24 (§3.8). */
export const RING_R = 9;
/** Circunferência 2π·9. */
export const RING_C = 2 * Math.PI * RING_R;

function frac(v: number): number {
  if (!Number.isFinite(v) || v <= 0) return 0;
  return Math.min(v, 1);
}

/** Anel de progresso estático (§3.8 `ProgressRing`): trilho a 16% e arco a partir do topo, no sentido horário. */
export function ProgressRing({ fraction, size = 24, standalone = false }: ProgressRingProps) {
  const f = frac(fraction);
  const dash = Math.round(f * RING_C * 1000) / 1000;
  const state = f === 0 ? 'empty' : f === 1 ? 'complete' : 'partial';
  return (
    <svg
      class="progress-ring"
      data-testid="progress-ring"
      data-state={state}
      data-dataviz=""
      width={size}
      height={size}
      viewBox="0 0 24 24"
      focusable="false"
      role={standalone ? 'img' : undefined}
      aria-label={standalone ? t('ring.aria', { S: fmtSections(f) }) : undefined}
      aria-hidden={standalone ? undefined : 'true'}
    >
      <circle class="progress-ring__track" cx="12" cy="12" r={RING_R} stroke-width="3" />
      {f > 0 && (
        <circle
          class="progress-ring__arc"
          cx="12"
          cy="12"
          r={RING_R}
          stroke-width="3"
          stroke-dasharray={`${dash} ${Math.round(RING_C * 1000) / 1000}`}
          transform="rotate(-90 12 12)"
        />
      )}
    </svg>
  );
}
